module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page iv. ",
      "epub:type": "pagebreak",
      "id": "piv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("© 2024 by John Gallagher. All rights reserved. No part of this book may be reproduced without formal permission.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("ISBN 9780814351482 (hardcover)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN 9780814351499 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Control Number: 2024934526")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Jacket design by Brad Norr Design.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Publication of this book was made possible through the generosity of the Friends of the Great Lakes Books Series Fund.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Wayne State University Press rests on Waawiyaataanong, also referred to as Detroit, the ancestral and contemporary homeland of the Three Fires Confederacy. These sovereign lands were granted by the Ojibwe, Odawa, Potawatomi, and Wyandot Nations, in 1807, through the Treaty of Detroit. Wayne State University Press affirms Indigenous sovereignty and honors all tribes with a connection to Detroit. With our Native neighbors, the press works to advance educational equity and promote a better future for the earth and all people.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Wayne State University Press")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Leonard N. Simons Building")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("4809 Woodward Avenue")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Detroit, Michigan 48201-1309")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Visit us online at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.wsupress.wayne.edu",
      "target": "_blank"
    }
  }, [_vm._v("wsupress.wayne.edu")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("References to internet websites (URLs) were accurate at the time of writing. Neither the author nor Wayne State University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-536d5038","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-gallagher-0006.vue
// module id = 69
// module chunks = 0